import React, { useState, useEffect } from 'react'
import {
  Box,
  TextField,
  Button,
  List,
  ListItem,
  ListItemText,
  Typography,
  Divider,
  IconButton,
} from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import api from '../../../config/api'

// Предположим, что ваш API-класс выглядит примерно так:

const DeliveryAddresses = () => {
  const [addresses, setAddresses] = useState([])
  const [newCity, setNewCity] = useState('')
  const [newAddress, setNewAddress] = useState('')

  // Загрузка данных с API
  useEffect(() => {
    const loadAddresses = async () => {
      try {
        const response = await api.get('/API_FRONT/user/locations/') // Предполагаем, что fetchLocations() возвращает список адресов
        setAddresses(response.data)
      } catch (error) {
        console.error('Ошибка загрузки адресов:', error)
      }
    }
    loadAddresses()
  }, [])

  const handleAddAddress = async () => {
    if (newCity.trim() && newAddress.trim()) {
      const newEntry = { city: newCity, location: newAddress }
      try {
        await api.post('API_FRONT/user/locations/add', newEntry) // Добавьте метод для записи нового адреса
        setAddresses([...addresses, newEntry]) // Обновляем состояние локально
        setNewCity('')
        setNewAddress('')
      } catch (error) {
        console.error('Ошибка добавления нового адреса:', error)
      }
    }
  }

  const handleDeleteAddress = async (index) => {
    const addressToDelete = addresses[index]
    try {
      await api.post('/API_FRONT/user/locations/delete', {
        id: addressToDelete?.id,
      }) // Удаляем через API

      const updatedAddresses = addresses.filter((_, i) => i !== index)
      setAddresses(updatedAddresses) // Обновляем состояние локально
    } catch (error) {
      console.error('Ошибка удаления адреса:', error)
    }
  }

  return (
    <Box sx={{ width: '100%', maxWidth: 600, margin: '0 auto', padding: 2 }}>
      <Typography variant="h4" gutterBottom>
        Адреса доставки
      </Typography>
      {addresses.length == 0 && (
        <Typography variant="body1" gutterBottom>
          Пусто
        </Typography>
      )}
      <List>
        {addresses.map((addr, index) => (
          <React.Fragment key={index}>
            <ListItem
              secondaryAction={
                <IconButton
                  edge="end"
                  aria-label="delete"
                  onClick={() => handleDeleteAddress(index)}
                >
                  <DeleteIcon />
                </IconButton>
              }
            >
              <ListItemText
                primary={`г. ${addr.city}`}
                secondary={addr.address || addr.location}
              />
            </ListItem>
            <Divider />
          </React.Fragment>
        ))}
      </List>

      <Box sx={{ marginTop: 4 }}>
        <Typography variant="h6" gutterBottom>
          Добавить новый адрес
        </Typography>
        <TextField
          label="Город"
          variant="outlined"
          fullWidth
          margin="normal"
          value={newCity}
          onChange={(e) => setNewCity(e.target.value)}
        />
        <TextField
          label="Адрес"
          variant="outlined"
          fullWidth
          margin="normal"
          value={newAddress}
          onChange={(e) => setNewAddress(e.target.value)}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={handleAddAddress}
          sx={{ marginTop: 2 }}
        >
          Добавить адрес
        </Button>
      </Box>
    </Box>
  )
}

export default DeliveryAddresses
